export const sendgridPreferencesPath = '/account/details';
export const setupGuidePath = '/guide';
export const supportUrl = 'https://support.sendgrid.com/hc/en-us';
export const userSettingsPath = '/user/user-settings';
